import startCase from 'lodash/startCase'

// It would typically make sense for somewhere using this to be co-located with this component,
// but we're going to backfill this value into contacts where `name` is missing, so this is a temp solution.
export function emailToName(email: string) {
  return startCase(email.split('@')[0].replaceAll('.', ' '))
}
